var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Besucher")]),_c('vue-c3',{attrs:{"handler":_vm.handler,"id":"visitor"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }